<template>
  <div>
    <v-card tile flat class="my-5" v-if="!this.$isObject(this.peserta_lulus)">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"> </div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">
              <v-row dense>
                <v-col cols="12" md="7">
                  Selamat Datang, <strong>{{ ptk.nama }}</strong>
                </v-col>
                <v-col v-if="isFspLulus" cols="12" md="5" class="text-right right-aligned">
                  <v-chip class="caption" color="indigo" dark> FSP Angkatan {{ $getDeepObj(pa, 'gelombang') }} </v-chip>
                </v-col>
              </v-row>
            </h1>
            <template v-if="Object.keys(instruktur_cadangan).length || Object.keys(peserta_cadangan).length">
              <h3>Program Sekolah Penggerak</h3>
              <template v-if="Object.keys(peserta_cadangan).length">
                <p class="black--text body-2">
                  Bapak/Ibu adalah Kepala Sekolah yang telah lulus proses seleksi calon Kepala Sekolah Program Sekolah
                  Penggerak angkatan
                  {{ $getDeepObj(peserta_cadangan, 'gelombang') || 1 }}
                  dan kembali mengikuti seleksi calon Kepala Sekolah di angkatan 3. Data hasil asesmen Bapak/Ibu sudah
                  tersimpan di dalam sistem dan akan diproses di tahap akhir seleksi.
                </p>
                <p class="black--text body-2">
                  Bapak/Ibu hanya perlu melakukan proses pendaftaran & menunggu informasi selanjutnya yang akan
                  diumumkan melalui e-mail dan SIMPKB.<br />
                  Terima kasih.
                </p>
              </template>
              <template v-if="Object.keys(instruktur_cadangan).length">
                <template v-if="Number(instruktur_cadangan.is_cadangan) === 1">
                  <p class="black--text body-2">
                    Dalam rangka memenuhi kebutuhan Fasilitator pelaksana Program Sekolah Penggerak angkatan II, kami
                    membuka kesempatan kepada Bapak/Ibu peserta seleksi calon Fasilitator angkatan I untuk kembali
                    berpartisipasi dalam seleksi Fasilitator angkatan II.
                  </p>
                  <p class="black--text body-2">
                    Kami mengundang Bapak/Ibu untuk mengikuti <b>seleksi tahap 2 calon Fasilitator angkatan II</b>.
                    Jadwal seleksi akan diumumkan pada portal dan SIMPKB.
                  </p>
                  <p class="black--text body-2">
                    Bagi Bapak/Ibu yang bersedia untuk mengikuti proses seleksi, harap melakukan registrasi ulang dan
                    pemutakhiran data riwayat hidup dan unggah dokumen paling lambat 10 Oktober 2021.
                  </p>
                  <p class="black--text body-2">
                    Silahkan klik <b>DAFTAR SEKARANG</b> untuk melanjutkan proses registrasi ulang.
                  </p>
                </template>
                <template v-if="Number(instruktur_cadangan.is_cadangan) === 2">
                  <p class="black--text body-2">
                    Dalam rangka memenuhi kebutuhan fasilitator Program Sekolah Penggerak angkatan II, kami membuka
                    kesempatan kepada Bapak/Ibu peserta seleksi fasilitator angkatan I untuk berpartisipasi kembali
                    dalam seleksi fasilitator angkatan II.
                  </p>
                  <p class="black--text body-2">
                    Kami mengundang Bapak/Ibu untuk mengikuti <b>seleksi tahap akhir calon fasilitator angkatan II</b>.
                  </p>
                  <p class="black--text body-2">
                    Bagi Bapak/Ibu yang bersedia untuk mengikuti proses seleksi, harap melakukan registrasi ulang dan
                    pemutakhiran data riwayat hidup dan unggah dokumen melalui akun SIMPKB paling lambat 10 Oktober
                    2021.
                  </p>
                  <p class="black--text body-2">
                    Silahkan klik <b>DAFTAR SEKARANG</b> untuk melanjutkan proses registrasi ulang.
                  </p>
                </template>
              </template>
              <v-btn
                color="secondary darken-1"
                @click="Object.keys(instruktur_cadangan).length ? onDaftarPaCadang() : onDaftar()"
                >Daftar Sekarang</v-btn
              >
            </template>
            <template v-else-if="Object.keys(registrasi).length">
              <h3>Program Sekolah Penggerak</h3>
              <template v-if="registrasi && registrasi.tutup">
                <v-alert icon="mdi-information" colored-border border="left" class="pa-2 my-2 bg-notif" color="error">
                  {{ registrasi.tutup }}
                </v-alert>
              </template>
              <template v-else>
                <p class="black--text body-2">
                  Anda berkesempatan menjadi bagian dari <b>Program Sekolah Penggerak</b>. Apakah Anda berminat, jika
                  iya silahkan klik tombol <b>Daftar Sekarang</b> di bawah ini.
                </p>
                <v-btn color="secondary darken-1" @click="onDaftar">Daftar Sekarang</v-btn>
              </template>
            </template>
            <template v-else>
              <h3>Program Sekolah Penggerak</h3>
              <v-alert icon="mdi-information" colored-border border="left" class="pa-2 my-2 bg-notif" color="error">
                Saat ini Anda belum memenuhi persyaratan untuk mengikuti pendaftaran Program Sekolah Penggerak. Info
                lebih lengkap silakan cek
                <a
                  class="blue--text"
                  href="https://sekolah.penggerak.kemdikbud.go.id/programsekolahpenggerak/"
                  target="_blank"
                >
                  disini
                </a>
              </v-alert>
              <v-btn color="secondary darken-1" disabled @click="onDaftar">Daftar Sekarang</v-btn>
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row class="mb-3">
      <template v-for="(menu, i) in menus">
        <v-col cols="12" md="4" lg="4" :key="i" v-if="$allow(menu.akses)">
          <template v-if="!menu.hasOwnProperty('sidebar')">
            <base-card-menus v-bind="menu" @action="onAction" :disable="menu.disable"> </base-card-menus>
          </template>
        </v-col>
      </template>
    </v-row>

    <form-daftar
      ref="formDaftar"
      :master="master"
      :unsurEror="unsurEror"
      :registrasi="registrasi"
      :preferensi="preferensi"
      @daftar="onDaftarInfo"
      @resetUnsurError="onResetUnsurError"
    ></form-daftar>

    <component
      ref="formulir"
      :is="formulir['component']"
      :instansi-kasek="formulir['instansiKasek']"
      :params="formulir['params']"
      :ptk="ptk"
      :tipe="daftarKasek ? 'kasek' : 'pa'"
      :details="infoDetails"
      @reload="onReloadPage"
      @lapor="onFormLapor"
    ></component>

    <base-modal-full ref="modal" generalError :title="formulirModal.title" @save="onAction(formulirModal.action)">
      <component
        ref="modalForm"
        :is="formulirModal['component']"
        :initValue="formulirModal['initValue']"
        :ptk="ptk"
      ></component>
    </base-modal-full>

    <popup-notifikasi
      ref="notifikasi"
      :notif="formulir.notif"
      @action="onAction({ action: $getDeepObj(formulir, 'notif.action') })"
    ></popup-notifikasi>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseCardMenus from '@components/base/BaseCardMenus';
import mixinAction from '@mixins/action';
import mixinRegistrasi from './mixin.registrasi';
import notif from '@views/gtk/home/notif';
import FormDaftarInfo from '@components/popup/DaftarInfo';
import FormDaftarKasek from '@components/popup/DaftarKasek';
import FormDaftarLapor from '@components/popup/DaftarLapor';
import PopupNotifikasi from '@components/popup/Notifikasi';
export default {
  name: 'Unregister',
  mixins: [mixinAction, mixinRegistrasi, notif],
  components: {
    BaseCardMenus,
    FormDaftarInfo,
    FormDaftarKasek,
    FormDaftarLapor,
    PopupNotifikasi,
    FormDaftar: () => import('@components/popup/Daftar'),
    FormDkp: () => import('@components/form/DkpPeserta'),
  },
  data() {
    return {
      timezone: 'WIB',
      timeAkses: false,
      formulir: {},
      formulirModal: {},
      indexNotif: 0,
    };
  },
  computed: {
    ...mapState('preferensi', {
      menu: (state) => state.menu || {},
      notifikasi: (state) => state.notifikasi || [],
      ptk: (state) => state.data?.ptk ?? {},
      dpp: (state) => state.data?.dpp ?? {},
      peserta: (state) => state.data?.peserta ?? {},
      peserta_lulus: (state) => state.data?.peserta_lulus ?? {},
      preferensi: (state) => state.data ?? {},
      config: (state) => state.data.config || {},
      isDiklatSmk: (state) => state.data?.is_diklat_smk ?? false,
      isBlokir: (state) => state.isBlokir,
      pelatih_ahli: (state) => state.data?.pelatih_ahli ?? {},
      pelatihan: (state) => state.data?.pelatihan ?? [],
      serverDate: (state) => state.date,
    }),

    menus() {
      return this.$store.state.menus || [];
    },
  },
  mounted() {
    this.renderNotif(0);
  },
  methods: {
    ...mapActions('preferensi', ['getPreferensi']),

    linkPkpPengawas() {
      this.$closeNotif();
      this.$router.push({ name: 'diklat-komite-pengawas' });
    },

    linkDkp() {
      this.$closeNotif();
      this.$router.push({ name: 'pkp-peserta' });
    },

    linkBioFsp() {
      this.$closeNotif();
      this.$router.push({ name: 'biodata-fsp' });
    },

    // renderNotif() {
    //   const notif = ['notifAkunBelajar', 'notifBiodataFsp', 'notifBos', 'notifSurvey', 'notifSurveyKinerja'];
    //   if (!(notif && notif.length)) return;
    //
    //   const { msg, opt } = this[`${notif[this.indexNotif]}`]();
    //   const title = opt.title || 'Pengumuman';
    //   if (msg && msg.length) {
    //     this.$notifikasi(
    //       msg.join(''),
    //       title,
    //       Object.assign({}, this.optNotif, opt, {
    //         action: notif.length - 1 > this.indexNotif ? this.renderNotif : false,
    //       })
    //     );
    //     this.indexNotif++;
    //   } else {
    //     if (this.indexNotif >= notif.length - 1) return;
    //     this.indexNotif++;
    //     this.renderNotif();
    //   }
    // },
  },

  watch: {
    isBlokir: {
      handler(value) {
        if (value) {
          this.indexNotif = 0;
          this.renderNotif();
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
